import { Icon, SvgForward5 } from '@loomhq/lens';
import classNames from 'classnames';
import React from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { useDispatch, useSelector } from 'react-redux';

import { ROLLOUT_WEAVE, VARIANT } from 'constants/featureFlag';
import { PLAYER_LONG_STEP } from 'constants/videoPlayer';
import { skipForward, skipForwardEditMode } from 'creators/videoPlayer';
import { selectInTrimMode } from 'selectors/shareVideo';

import { useFeatureFlagValue } from 'hooks/featureFlag';

import ControlBarButton from '../control-bar-button';

import { useClipsState } from 'components/share-video/edit-tools/clips/state';

import './styles.less';

export default function StepForwardFiveButton(props) {
  const dispatch = useDispatch();
  const weaveFlagValue = useFeatureFlagValue(ROLLOUT_WEAVE);
  const rolloutWeave = VARIANT.includes(weaveFlagValue);
  const inTrimMode = useSelector(selectInTrimMode);

  const clipsState = useClipsState(state => ({
    clips: state.clips,
    focusedClipIndex: state.focusedClipIndex,
    updateFocusedClipIndex: state.updateFocusedClipIndex,
    updateFocusedPlayRangeIndex: state.updateFocusedPlayRangeIndex,
  }));

  const stepForward = () => {
    if (inTrimMode && rolloutWeave) {
      dispatch(skipForwardEditMode(PLAYER_LONG_STEP, clipsState));
    } else {
      dispatch(skipForward());
    }
  };

  useHotkeys('l, right', stepForward, [inTrimMode, clipsState]);

  return (
    <ControlBarButton
      className={classNames('step-forward-five-button', {
        'crowded-embed': props.crowded && !props.isMainVideoOnSharePage,
      })}
      hoverTagText="Step Forward (l)"
      seeking={props.seeking}
      onClick={stepForward}
    >
      <Icon
        color="white"
        className="control-bar-button-icon"
        icon={<SvgForward5 />}
      />
    </ControlBarButton>
  );
}
